import { connectSocket } from '@/utils/websocket'
import { getCache } from '@/utils/cache'

export default {
  beforeDestroy() { this.stopOrderSocket() },
  methods: {
    stopOrderSocket() { this.orderSocketGeneration = (this.orderSocketGeneration || 0) + 1; if (this.orderSocket) this.orderSocket(); this.orderSocket = null },
    startOrderSocket() {
      this.stopOrderSocket()
      const contractId = this.contractId, generation = this.orderSocketGeneration, user = getCache('userInfo') || {}
      const contract = (this.contracts || []).find(item => Number(item.id) === Number(contractId))
      const userId = Number(contract && contract.user_id || user.user_id)
      if (this.disposed || this.infoTab || !contractId || !(userId > 0) || this.contractStatus !== 0) return
      const checks = {}
      const current = () => !this.disposed && !this.infoTab && generation === this.orderSocketGeneration && this.contractId === contractId && this.contractStatus === 0
      const confirmList = async kind => {
        const check = checks[kind] || (checks[kind] = { busy: false, last: -Infinity })
        // A stale push endpoint must not create a new HTTP request every two seconds.
        if (check.busy || Date.now() - check.last < 15000) return
        check.busy = true; check.last = Date.now()
        const request = this.orderRequest
        try {
          const rows = await this.allPages(kind === 'positions' ? 'vexe/v1/contract/positionList' : 'vexe/v1/contract_order/orderList', { contract_id: contractId, ...(kind === 'pending' ? { status: 1, pending_only: 1 } : {}) }, request, 'orderRequest')
          if (current() && request === this.orderRequest && Array.isArray(rows)) this[kind] = rows
        } catch (_) { /* Retain the last authenticated snapshot; retry on a later push. */ }
        finally { check.busy = false }
      }
      this.orderSocket = connectSocket({ url: ((getCache('config_data') || {}).site || {}).websocket, interval: 2000,
        getMessages: () => document.hidden || !current() ? [] : [
          { data: 'getContractPositionList', contract_id: contractId, user_id: userId, userId },
          { data: 'getContractInfo', contract_id: contractId, user_id: userId, userId },
          { data: 'getContractOrderList', contract_id: contractId, user_id: userId, userId }
        ].filter(message => !this.orderSocketKinds || message.data === 'getContractInfo' || this.orderSocketKinds.includes(message.data === 'getContractPositionList' ? 'positions' : 'pending')),
        onMessage: data => {
          if (!data || !current() || this.loading) return
          if (data.contract_id != null && Number(data.contract_id) !== Number(contractId)) return
          if (data.socket_type === 'contract_info' && data.data && Number(data.data.id) === Number(contractId)) this.liveContractInfo = data.data
          if (!Array.isArray(data.list)) return
          const kind = data.socket_type === 'contract_position' ? 'positions' : data.socket_type === 'contract_order' ? 'pending' : null
          if (!kind) return
          if (this.orderSocketKinds && !this.orderSocketKinds.includes(kind)) return
          const rowId = item => kind === 'positions' ? (item.position_id ?? item.id) : item.id
          if (data.list.some(item => !item || rowId(item) == null || (item.contract_key != null && Number(item.contract_key) !== Number(contractId)) || (item.user_id != null && Number(item.user_id) !== userId))) return
          // The shared H5 worker only pushes status 1. Other pending states remain
          // authoritative HTTP snapshots, not deletions inferred from that subset.
          const rows = kind === 'pending' ? data.list.filter(item => Number(item.status) === 1) : data.list
          const previous = this[kind], byId = new Map(rows.map(item => [String(rowId(item)), item]))
          const pushedPrevious = kind === 'pending' ? previous.filter(item => Number(item.status) === 1) : previous
          if (pushedPrevious.length !== rows.length || pushedPrevious.some(item => !byId.has(String(rowId(item))))) return confirmList(kind)
          // Preserve HTTP-only fields when a push contains only quote/quantity updates.
          this[kind] = previous.map(item => ({ ...item, ...byId.get(String(rowId(item))) }))
          if (kind === 'pending' && previous.some(item => Number(item.status) !== 1)) confirmList(kind)
        }
      })
    }
  }
}
